import type { Components, Theme } from '@mui/material/styles'
import { colorTokens } from '../tokens/colorTokens'

export const selectTheme: Components<Theme> = {
    MuiFormControl: {
        defaultProps: {
            margin: 'dense',
            variant: 'outlined',
        },
    },
    MuiSelect: {
        defaultProps: {
            variant: 'outlined',
        },
        styleOverrides: {
            root: ({ theme }) => ({
                '&.MuiSelect-inRow': {
                    minHeight: 28,
                    borderRadius: theme.shape.borderRadius,
                    fontSize: theme.typography.body2.fontSize,
                },
            }),
        },
        variants: [
            {
                // LeftNav select option needs the 'light' variant for dark background (like LeftNav language select)
                props: { color: 'light' },
                style: {
                    '& .MuiSelect-icon': {
                        color: 'rgba(255, 255, 255, 0.7)',
                    },
                },
            },
        ],
    },
    MuiOutlinedInput: {
        styleOverrides: {
            root: {
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: colorTokens.border.focus,
                    borderWidth: '1px',
                },
            },
        },
        variants: [
            // LeftNav outlined input needs the 'light' variant for dark background (like LeftNav language select)
            {
                props: { color: 'light' },
                style: {
                    color: colorTokens.text.contrast,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(255, 255, 255, 0.5)',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'rgba(255, 255, 255, 0.7)',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: colorTokens.text.contrast,
                    },
                },
            },
        ],
    },
}
